<svg style="display: none" aria-hidden="true">
	<defs>
		<symbol id="psi-success-icon" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				d="M8.83464 13.8327L14.7096 7.95768L13.543 6.79102L8.83464 11.4993L6.45964 9.12435L5.29297 10.291L8.83464 13.8327ZM10.0013 18.3327C8.84852 18.3327 7.76519 18.1139 6.7513 17.6764C5.73741 17.2389 4.85547 16.6452 4.10547 15.8952C3.35547 15.1452 2.76172 14.2632 2.32422 13.2493C1.88672 12.2355 1.66797 11.1521 1.66797 9.99935C1.66797 8.84657 1.88672 7.76324 2.32422 6.74935C2.76172 5.73546 3.35547 4.85352 4.10547 4.10352C4.85547 3.35352 5.73741 2.75977 6.7513 2.32227C7.76519 1.88477 8.84852 1.66602 10.0013 1.66602C11.1541 1.66602 12.2374 1.88477 13.2513 2.32227C14.2652 2.75977 15.1471 3.35352 15.8971 4.10352C16.6471 4.85352 17.2409 5.73546 17.6784 6.74935C18.1159 7.76324 18.3346 8.84657 18.3346 9.99935C18.3346 11.1521 18.1159 12.2355 17.6784 13.2493C17.2409 14.2632 16.6471 15.1452 15.8971 15.8952C15.1471 16.6452 14.2652 17.2389 13.2513 17.6764C12.2374 18.1139 11.1541 18.3327 10.0013 18.3327ZM10.0013 16.666C11.8624 16.666 13.4388 16.0202 14.7305 14.7285C16.0221 13.4368 16.668 11.8605 16.668 9.99935C16.668 8.13824 16.0221 6.56185 14.7305 5.27018C13.4388 3.97852 11.8624 3.33268 10.0013 3.33268C8.14019 3.33268 6.5638 3.97852 5.27214 5.27018C3.98047 6.56185 3.33464 8.13824 3.33464 9.99935C3.33464 11.8605 3.98047 13.4368 5.27214 14.7285C6.5638 16.0202 8.14019 16.666 10.0013 16.666Z" />
		</symbol>
		<symbol id="psi-error-icon" viewBox="0 0 20 20">
			<path
				fill="currentColor"
				d="M10.5951 13.9284C10.7548 13.7687 10.8346 13.5707 10.8346 13.3346C10.8346 13.0985 10.7548 12.9006 10.5951 12.7409C10.4353 12.5812 10.2374 12.5013 10.0013 12.5013C9.76519 12.5013 9.56727 12.5812 9.40755 12.7409C9.24783 12.9006 9.16797 13.0985 9.16797 13.3346C9.16797 13.5707 9.24783 13.7687 9.40755 13.9284C9.56727 14.0881 9.76519 14.168 10.0013 14.168C10.2374 14.168 10.4353 14.0881 10.5951 13.9284ZM9.16797 10.8346H10.8346V5.83464H9.16797V10.8346ZM10.0013 18.3346C8.84852 18.3346 7.76519 18.1159 6.7513 17.6784C5.73741 17.2409 4.85547 16.6471 4.10547 15.8971C3.35547 15.1471 2.76172 14.2652 2.32422 13.2513C1.88672 12.2374 1.66797 11.1541 1.66797 10.0013C1.66797 8.84852 1.88672 7.76519 2.32422 6.7513C2.76172 5.73741 3.35547 4.85547 4.10547 4.10547C4.85547 3.35547 5.73741 2.76172 6.7513 2.32422C7.76519 1.88672 8.84852 1.66797 10.0013 1.66797C11.1541 1.66797 12.2374 1.88672 13.2513 2.32422C14.2652 2.76172 15.1471 3.35547 15.8971 4.10547C16.6471 4.85547 17.2409 5.73741 17.6784 6.7513C18.1159 7.76519 18.3346 8.84852 18.3346 10.0013C18.3346 11.1541 18.1159 12.2374 17.6784 13.2513C17.2409 14.2652 16.6471 15.1471 15.8971 15.8971C15.1471 16.6471 14.2652 17.2409 13.2513 17.6784C12.2374 18.1159 11.1541 18.3346 10.0013 18.3346ZM10.0013 16.668C11.8624 16.668 13.4388 16.0221 14.7305 14.7305C16.0221 13.4388 16.668 11.8624 16.668 10.0013C16.668 8.14019 16.0221 6.5638 14.7305 5.27214C13.4388 3.98047 11.8624 3.33464 10.0013 3.33464C8.14019 3.33464 6.5638 3.98047 5.27214 5.27214C3.98047 6.5638 3.33464 8.14019 3.33464 10.0013C3.33464 11.8624 3.98047 13.4388 5.27214 14.7305C6.5638 16.0221 8.14019 16.668 10.0013 16.668Z" />
		</symbol>
	</defs>
</svg>

<mat-card @list class="info-card">
	<mat-card-content>
		<div class="info-row" @items *ngIf="passwordComponent.enableLowerCaseLetterRule">
			<div *ngIf="passwordComponent.containAtLeastOneLowerCaseLetter; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="lowerCaseCriteriaMsg"></span>
		</div>

		<div class="info-row" @items *ngIf="passwordComponent.enableUpperCaseLetterRule">
			<div *ngIf="passwordComponent.containAtLeastOneUpperCaseLetter; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="upperCaseCriteriaMsg"></span>
		</div>

		<div class="info-row" @items *ngIf="passwordComponent.enableDigitRule">
			<div *ngIf="passwordComponent.containAtLeastOneDigit; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="digitsCriteriaMsg"></span>
		</div>

		<div class="info-row" @items *ngIf="passwordComponent.enableSpecialCharRule">
			<div *ngIf="passwordComponent.containAtLeastOneSpecialChar; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="specialCharsCriteriaMsg"></span>
		</div>

		<div class="info-row" @items *ngIf="passwordComponent.enableLengthRule">
			<div *ngIf="passwordComponent.containAtLeastMinChars; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="minCharsCriteriaMsg"></span>
		</div>

		<div class="info-row" @items *ngIf="passwordComponent.customValidator">
			<div *ngIf="passwordComponent.containAtCustomChars; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="customCharsCriteriaMsg"></span>
		</div>

		<div *ngIf="enableScoreInfo" class="info-row" @items>
			<div *ngIf="passwordComponent.strength === 100; then done; else error"></div>
			<ng-template #done>
				<svg @positiveState class="psi-icon psi-icon--success" width="20" height="20" aria-hidden="true">
					<use href="#psi-success-icon" />
				</svg>
			</ng-template>
			<ng-template #error>
				<svg @negativeState class="psi-icon psi-icon--error" width="20" height="20" aria-hidden="true">
					<use href="#psi-error-icon" />
				</svg>
			</ng-template>
			<span [innerHTML]="'Password strength: ' + passwordComponent.strength + '%'"></span>
		</div>
	</mat-card-content>
</mat-card>
